import Vue from "vue";

Vue.mixin({
  methods: {
    onlyNumbers(event) {
      const isNumber =
        (!event.shiftKey && event.keyCode > 47 && event.keyCode < 58) ||
        (event.keyCode > 95 && event.keyCode < 106);
      const isAllowed = //SELECT ALL COPY PASTE CUT DELETE BACKSPACE
        (event.ctrlKey &&
          (event.keyCode === 65 ||
            event.keyCode === 88 ||
            event.keyCode === 67 ||
            event.keyCode === 86)) ||
        event.keyCode === 46 ||
        event.keyCode === 8 ||
        event.keyCode === 9;
      if (!isNumber && !isAllowed) {
        event.preventDefault();
      }
    },
    filterDropdownFistLetter(options, label, search) {
      return label.toLowerCase().indexOf(search.toLowerCase()) === 0;
    }
  }
});
